import { render } from "./ModalFunctions.vue?vue&type=template&id=7b8f6115"
import script from "./ModalFunctions.vue?vue&type=script&lang=js"
export * from "./ModalFunctions.vue?vue&type=script&lang=js"

import exportComponent from "/home/melvin/Workspace/Sjef.app/frontend/pos.sjef.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__